type TOrganizationLike = { id: string };

export type TLayoutsProbe = { status: 'pending' } | { status: 'error' } | { status: 'success'; count: number };

const shouldShowOrganization = (probe: TLayoutsProbe | undefined) =>
  probe?.status === 'error' || (probe?.status === 'success' && probe.count > 0);

export const filterOrganizationsWithLayouts = <TOrganization extends TOrganizationLike>(
  organizations: TOrganization[],
  probes: Array<TLayoutsProbe | undefined>,
): TOrganization[] => organizations.filter((_, index) => shouldShowOrganization(probes[index]));
